import { render, staticRenderFns } from "./InterProcessConfigurationPage.vue?vue&type=template&id=786c3a16&"
import script from "./InterProcessConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./InterProcessConfigurationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786c3a16')) {
      api.createRecord('786c3a16', component.options)
    } else {
      api.reload('786c3a16', component.options)
    }
    module.hot.accept("./InterProcessConfigurationPage.vue?vue&type=template&id=786c3a16&", function () {
      api.rerender('786c3a16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/InterProcessConfigurationPage.vue"
export default component.exports